module.exports = __webpack_public_path__ + "img/KORE-alt.eeb213b0.svg";